<template>
  <aside class="w-full md:w-64 bg-sidebar border-b md:border-b-0 md:border-r border-sidebar-border flex flex-col shadow-lg">
    <div class="p-6 border-b border-sidebar-border flex flex-col items-center gap-3 bg-red-600">
      <img src="/images/curem.png" alt="CUREM" width="120" height="40" class="object-contain" />
      <p class="text-xs text-white text-center font-medium tracking-wide uppercase">Planejamento Estratégico 2026</p>
    </div>

    <nav class="flex-1 p-4 overflow-y-auto">
      <ul class="space-y-1">
        <li v-for="item in itemsToRender" :key="item.id">
          <router-link
            :to="`/${item.id}`"
            :class="[
              'w-full flex items-center gap-3 px-4 py-3 rounded-xl text-left transition duration-200 transform',
              isActive(`/${item.id}`)
                ? 'bg-sidebar-primary text-sidebar-primary-foreground shadow-md scale-105'
                : 'text-sidebar-foreground hover:bg-sidebar-accent hover:scale-105',
            ]"
          >
            <component :is="item.icon" :className="'w-5 h-5 flex-shrink-0'" />
            <span class="text-sm font-medium">{{ item.label }}</span>
          </router-link>
        </li>
      </ul>
    </nav>
  </aside>
</template>

<script>
import IconLayoutDashboard from '@/components/icons/IconLayoutDashboard.vue'
import IconTrendingUpMenu from '@/components/icons/IconTrendingUpMenu.vue'
import IconMegaphone from '@/components/icons/IconMegaphone.vue'
import IconPackage from '@/components/icons/IconPackage.vue'
import IconShoppingCart from '@/components/icons/IconShoppingCart.vue'
import IconUsers from '@/components/icons/IconUsers.vue'
import IconCpu from '@/components/icons/IconCpu.vue'
import IconTruck from '@/components/icons/IconTruck.vue'
import IconGraduationCap from '@/components/icons/IconGraduationCap.vue'

import { hasPermission } from '@/services/auth'

const menuItems = [
  { id: 'geral-comercial', label: 'Dashboard Geral', icon: IconLayoutDashboard, permission: 100 },
  { id: 'comercial', label: 'Comercial', icon: IconTrendingUpMenu, permission: 102 },
  { id: 'marketing', label: 'Marketing', icon: IconMegaphone, permission: 104 },
  { id: 'operacoes', label: 'Operações', icon: IconPackage, permission: 106 },
  { id: 'compras', label: 'Compras', icon: IconShoppingCart, permission: 108 },
  { id: 'sucesso', label: 'Sucesso do Cliente', icon: IconUsers, permission: 110 },
  { id: 'ti', label: 'TI', icon: IconCpu, permission: 112 },
  { id: 'logistica', label: 'Logística', icon: IconTruck, permission: 114 },
  { id: 'academico', label: 'Acadêmico', icon: IconGraduationCap, permission: 116 },
]

export default {
  name: 'Sidebar',
  computed: {
    pathname() {
      return this.$route.path
    },
    isGeral() {
      return this.pathname === '/geral-comercial' || this.pathname === '/geral'
    },
    itemsToRender() {
      const allowed = menuItems.filter((item) => hasPermission(item.permission))
      // Mostra sempre todos os itens permitidos no menu.
      // (Antes o menu filtrava para exibir apenas o item da rota atual fora do "Geral".)
      return allowed
    },
  },
  methods: {
    isActive(href) {
      return this.pathname === href
    },
  },
}
</script>

